import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import s from './EmptyState.module.css';
export function EmptyState({ icon, title, body, cta, }) {
    return (_jsxs("div", { className: s.root, children: [icon && _jsx("div", { className: s.icon, children: icon }), _jsx("div", { className: s.title, children: title }), body && _jsx("div", { className: s.body, children: body }), cta && _jsx("div", { className: s.cta, children: cta })] }));
}
